<template>
  <div class="service">
    <Header
      :right-sidebar="true"
      :right-sidebar-title="`Редактирование службы`"
    >
      <template #right-sidebar>
        <sidebar-items-group title="Отображать столбцы">
          <fields-picker
            v-model="pickedFields"
            :fields="serviceHistoryDisplayableFields"
          />
        </sidebar-items-group>
        <sidebar-items-group title="Фильтры">
          <filters-group
            :fields="servicesHistoryFields"
            :items="serviceHistory"
            v-model="filteredItems"
          />
        </sidebar-items-group>
        <sidebar-item
          button
          variant="warning"
          @click="deleteService"
          :disabled="loading"
          v-if="!isDeleted"
        >
          Удалить службу
          <template #icon>
            <b-icon icon="x-square" />
          </template>
        </sidebar-item>
        <sidebar-item
          button
          variant="success"
          @click="restoreService"
          :disabled="loading"
          v-else
        >
          Восстановить службу
          <template #icon>
            <b-icon icon="box-arrow-up-right" />
          </template>
        </sidebar-item>
        <sidebar-item
          button
          variant="danger"
          @click="showPurgeConformalModal = true"
          :disabled="loading"
        >
          Удалить службу навсегда
          <template #icon>
            <b-icon icon="trash" />
          </template>
        </sidebar-item>
      </template>
    </Header>
    <Main>
      <h3 class="text-center">
        Редактирование службы
      </h3>
      <b-overlay :show="loading">
        <service-form
          v-model="serviceActualData"
          v-if="serviceActualData !== undefined"
          class="service__form"
        />
      </b-overlay>
    </Main>
    <Main>
      <b-overlay :show="loading">
        <h3 class="text-center">История изменений абонемента</h3>
        <b-table
          selectable
          select-mode="single"
          :responsive="true"
          :items="paintedRows"
          :fields="pickedFields"
          hover
          class="table-rounded"
          empty-text="Записей нет"
        />
      </b-overlay>
    </Main>
    <b-modal
      centered
      title="Окончательное удаление службы"
      v-model="showPurgeConformalModal"
      ok-title="Удалить"
      cancel-title="Отмена"
      ok-variant="danger"
      cancel-variant="success"
      @ok="purgeService"
    >
      <p class="my-4">
        Вы точно хотите удалить эту службу?<br />(История изменений службы будет
        безвозвратно утеряна, кроме того, все приписанные к этой службе люди,
        будут отписаны от неё)
      </p>
    </b-modal>
    <bottom-overlay v-if="edited">
      <b-button
        @click="updateService"
        block
        squared
        variant="success"
        class="service__update-button"
        :disabled="loading"
      >
        Сохранить изменения
      </b-button>
      <b-button
        @click="discardChanges"
        block
        squared
        variant="warning"
        class="service__discard-changes-button"
        :disabled="loading"
      >
        Отменить изменения
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import FieldsPicker from "@/components/Tables/FieldsPicker";
import SidebarItemsGroup from "@/components/Layout/Sidebars/SidebarItems/SidebarItemsGroup";
import FiltersGroup from "@/components/Tables/Filters/FiltersGroup";
import SidebarItem from "@/components/Layout/Sidebars/SidebarItems/SidebarItem";
import BottomOverlay from "@/components/BottomOverlay";
import { displayableFields } from "@/components/Tables/defaultFields";
import axios from "@/axios";
import Main from "@/components/Layout/Main";
import { mapActions } from "vuex";
import { defaultRowPainter } from "@/components/Tables/rowPainters";
import ServiceForm from "@/components/Forms/Service/ServiceForm";
import { servicesHistoryFields } from "@/views/Services/models/servicesTableModel";
import ServiceModel from "@/components/Forms/Service/models/serviceModel";
import pageTitleMixin from "@/mixins/pageTitleMixin";
export default {
  components: {
    ServiceForm,
    Main,
    BottomOverlay,
    SidebarItem,
    FiltersGroup,
    SidebarItemsGroup,
    FieldsPicker,
    Header
  },
  mixins: [pageTitleMixin],
  props: {
    serviceId: {
      type: Number,
      required: true
    }
  },
  data() {
    let serviceHistoryDisplayableFields = displayableFields(
      servicesHistoryFields
    );
    return {
      servicesHistoryFields,
      serviceHistoryDisplayableFields,
      filteredItems: [],
      pickedFields: serviceHistoryDisplayableFields,
      serviceHistory: [],
      serviceActualData: undefined,
      loading: true,
      showPurgeConformalModal: false
    };
  },
  computed: {
    isDeleted: ({ serviceHistory }) =>
      serviceHistory[0] !== undefined
        ? Boolean(Number(serviceHistory[0].is_deleted))
        : false,
    edited: ({ serviceActualData, serviceHistory }) =>
      serviceHistory[0] !== undefined &&
      JSON.stringify(serviceActualData) !==
        JSON.stringify(new ServiceModel(serviceHistory[0])),
    paintedRows: ({ filteredItems }) => defaultRowPainter(filteredItems)
  },
  methods: {
    ...mapActions("services", {
      storeLoadServices: "loadServices",
      storeUpdateService: "updateService",
      storeDeleteService: "deleteService",
      storeRestoreService: "restoreService",
      storePurgeService: "purgeService"
    }),
    async updateService() {
      this.loading = true;
      try {
        await this.storeUpdateService({
          id: this.serviceId,
          serviceData: this.serviceActualData
        });
        await this.loadData();
      } catch {
        this.loading = false;
      }
    },
    discardChanges() {
      this.serviceActualData = new ServiceModel(this.serviceHistory[0]);
    },
    async deleteService() {
      this.loading = true;
      await this.storeDeleteService(this.serviceId);
      await this.loadData();
    },
    async restoreService() {
      this.loading = true;
      await this.storeRestoreService(this.serviceId);
      await this.loadData();
    },
    async purgeService() {
      this.loading = true;
      await this.storePurgeService(this.serviceId);
      await this.$router.push(`/employees/services`);
    },
    async loadData() {
      this.serviceHistory = (
        await axios.get(`/employees/services/${this.serviceId}/history`)
      ).data.employee_service_history;
      this.serviceActualData = new ServiceModel(this.serviceHistory[0]);
      this.loading = false;
    }
  },
  async created() {
    await this.loadData();
  }
};
</script>

<style lang="scss">
.service {
  &__form {
    padding: 0 5px;
  }
}
</style>
